import {NinchatUIComposeMessage} from 'api/types/messages'
import {UIMessageProps} from 'components/Messages/types'
import lodash from 'lodash'

const NUMERIC_KEY_REGEX = /^\d+$/u

export const parseMessages = (message: UIMessageProps['message']): Record<string, Array<NinchatUIComposeMessage>> => {
    const uiMessages = Object.entries(message ?? {})
        .filter(([key]) => NUMERIC_KEY_REGEX.test(key))
        .map(([, value]) => value as NinchatUIComposeMessage)
        .filter(Boolean)

    const groupedMessages = uiMessages.reduce((acc: Array<NinchatUIComposeMessage & { groupIndex: number }>, currentMessage) => {
        const prevMessage = acc[acc.length - 1]
        const groupIndex = prevMessage?.element === currentMessage.element
            ? prevMessage?.groupIndex ?? 0
            : (prevMessage?.groupIndex ?? 0) + 1

        return [...acc, {
            ...currentMessage,
            groupIndex,
        }]
    }, [])

    return lodash.groupBy(groupedMessages, 'groupIndex')
}
